export const SCREEN_WIDTH_XXS = 390;
export const SCREEN_WIDTH_SM = 640;
export const SCREEN_WIDTH_MD = 768;
export const SCREEN_WIDTH_LG = 1024;
export const SCREEN_WIDTH_XL = 1280;
